export class SavedSearchApiRequest {
    public EditDID : string;
    public StrCrit : string;
}